import {get} from 'common/utils/http';

const root = 'api/v1/customer-dns-mapping';

// eslint-disable-next-line import/prefer-default-export
export const fetchDnsTrackerData = () => get(`${root}`);
